import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { orderDetailLayoutRoutes } from './lib.routes';
import { OrderDetailComponent } from './order-detail/order-detail.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonUiModule } from '@bst-frontend/common-ui';
import { LeftPanelComponent } from './order-detail/left-panel/left-panel.component';
import { RightPanelComponent } from './order-detail/right-panel/right-panel.component';
import { CustomerDetailsComponent } from './order-detail/left-panel/customer-details/customer-details.component';
import { OrderDetailsComponent } from './order-detail/left-panel/order-details/order-details.component';
import { PickupLocationModalComponent } from './order-detail/modals/pickup-location-modal/pickup-location-modal.component';
import { DeliveryLocationModalComponent } from './order-detail/modals/delivery-location-modal/delivery-location-modal.component';
import { FareDetailsComponent } from './order-detail/left-panel/fare-details/fare-details.component';
import { AddEstimateModalComponent } from './order-detail/modals/add-estimate-modal/add-estimate-modal.component';
import { AssignTruckModalComponent } from './order-detail/modals/assign-truck-modal/assign-truck-modal.component';
import { AssignDriverModalComponent } from './order-detail/modals/assign-driver-modal/assign-driver-modal.component';
import { VehicleAssignModalComponent } from './order-detail/modals/vehicle-assign-modal/vehicle-assign-modal.component';
import { ReadyDispatchModalComponent } from './order-detail/modals/ready-dispatch-modal/ready-dispatch-modal.component';
import { DeliverModalComponent } from './order-detail/modals/deliver-modal/deliver-modal.component';
import { ConfirmPaymentModalComponent } from './order-detail/modals/confirm-payment-modal/confirm-payment-modal.component';
import { ViewFareDetailsModalComponent } from './order-detail/modals/view-fare-details-modal/view-fare-details-modal.component';
import { ViewProductDiffComponent } from './order-detail/right-panel/view-product-diff/view-product-diff.component';
import { InvoiceComponent } from './order-detail/right-panel/invoice/invoice.component';
import { OrderPaidModalComponent } from './order-detail/modals/order-paid-modal/order-paid-modal.component';
import { PartLoadPickupLocationModalComponent } from './order-detail/modals/part-load-pickup-location-modal/part-load-pickup-location-modal.component';
import { updateFareModalComponent } from './order-detail/modals/update-fare-modal/update-fare-modal.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(orderDetailLayoutRoutes),
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    NgSelectModule,
    CommonUiModule,
  ],
  declarations: [
    OrderDetailComponent,
    LeftPanelComponent,
    RightPanelComponent,
    CustomerDetailsComponent,
    OrderDetailsComponent,
    PickupLocationModalComponent,
    DeliveryLocationModalComponent,
    PartLoadPickupLocationModalComponent,
    FareDetailsComponent,
    AddEstimateModalComponent,
    updateFareModalComponent,
    AssignTruckModalComponent,
    AssignDriverModalComponent,
    VehicleAssignModalComponent,
    ReadyDispatchModalComponent,
    DeliverModalComponent,
    ConfirmPaymentModalComponent,
    ViewFareDetailsModalComponent,
    ViewProductDiffComponent,
    InvoiceComponent,
    OrderPaidModalComponent,
  ],
  exports: [],
})
export class OrderDetailLayoutModule {}
